module.exports = __webpack_public_path__ + "img/news7-1.9450869b.png";